(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunavia-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lunavia-product-story')) {
  customElements.define('lunavia-product-story', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-story-source]');
      if (!source) return;
      const headings = [...source.querySelectorAll('h3')];
      const rangeContent = (start, end) => {
        const range = document.createRange();
        range.selectNodeContents(source);
        if (start) range.setStartAfter(start);
        if (end) range.setEndBefore(end);
        const box = document.createElement('div');
        box.append(range.cloneContents());
        return box;
      };
      const intro = rangeContent(null, headings[0]);
      intro.querySelector('h2')?.remove();
      const accordions = document.createDocumentFragment();
      let materialGroup = null;
      headings.forEach((heading, index) => {
        const content = rangeContent(heading, headings[index + 1]);
        const title = heading.textContent.trim();
        content.querySelectorAll('.ace-line').forEach(line => {
          if (!line.querySelector('.ace-line') && /^(?:As natural crystals vary|Variations in the color|Each crystal has its own)/.test(line.textContent.trim())) line.remove();
        });
        if (/materials\s*(?:&|and)?\s*details|specifications/i.test(title) && !materialGroup) {
          materialGroup = { title, content };
        } else {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = title;
          content.className = 'lv-story__detail';
          details.append(summary, content);
          accordions.append(details);
        }
      });
      if (materialGroup) {
        const rows = this.querySelector('[data-materials-rows]');
        const verified = this.querySelector('[data-verified-specs]');
        const listItems = verified ? [] : [...materialGroup.content.querySelectorAll('li')];
        listItems.forEach(item => {
          const text = item.textContent.replace(/\s+/g, ' ').trim();
          const split = text.indexOf(':');
          const label = split > -1 ? text.slice(0, split).trim() : text;
          const detail = split > -1 ? text.slice(split + 1).trim() : '';
          const count = detail.match(/^\d+\s+(?:natural\s+)?(?:beads?|pieces?|charms?|spacers?)/i);
          const row = document.createElement('tr');
          [label, count ? count[0] : '—', count ? detail.slice(count[0].length).replace(/^,\\s*/, '') : detail].forEach(value => {
            const cell = document.createElement('td');
            cell.textContent = value;
            row.append(cell);
          });
          rows.append(row);
          item.remove();
        });
        materialGroup.content.querySelectorAll('ul,ol').forEach(list => { if (!list.textContent.trim()) list.remove(); });
        this.querySelector('[data-materials-heading]').textContent = materialGroup.title;
        if (!verified) this.querySelector('[data-materials-extra]').append(materialGroup.content);
        this.querySelector('[data-story-materials]').hidden = false;
        this.querySelector('[data-materials-rows]').closest('.lv-story__table-wrap').hidden = listItems.length === 0;
      }
      this.querySelector('[data-story-intro]').append(intro);
      this.querySelector('[data-story-accordions]').append(accordions);
      source.hidden = true;
      this.dataset.ready = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
